import { __decorate, __metadata } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ApiService, UiBsOauthModule } from '@wlp/ui-bs-oauth';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

const SPE_VIEW_N_PRE_PIX_PROXY = '/spe-view-n-detran';
let SpeViewNDetran = class SpeViewNDetran {
    constructor(api) {
        this.api = api;
    }
    getStates() {
        const uri = `${SPE_VIEW_N_PRE_PIX_PROXY}/v1/detran/states`;
        return this.api.get(uri).pipe(map((result) => {
            if (result !== null && result !== undefined) {
                return result;
            }
            throw 'Houve um erro ao buscar os dados!';
        }), catchError((err) => {
            return of(err);
        }));
    }
    consultYpe(uf) {
        const uri = `${SPE_VIEW_N_PRE_PIX_PROXY}/v1/detran/consult-type/uf/${uf}`;
        return this.api.get(uri).pipe(map((result) => {
            if (result !== null && result !== undefined) {
                return result;
            }
            throw 'Houve um erro ao buscar os dados!';
        }), catchError((err) => {
            return of(err);
        }));
    }
    consultByRenavam(uf, type, renavam, uuidAccount) {
        const uri = `${SPE_VIEW_N_PRE_PIX_PROXY}/v1/detran/consult/uf/${uf}/type/${type}/renavam/${renavam}/account-payment/${uuidAccount}`;
        return this.api.get(uri).pipe(map((result) => {
            if (result !== null && result !== undefined) {
                return result;
            }
            throw 'Houve um erro ao buscar os dados!';
        }), catchError((err) => {
            return of(err);
        }));
    }
    getPaymentType(uuidAccount) {
        const uri = `${SPE_VIEW_N_PRE_PIX_PROXY}/v1/detran/payment-type/${uuidAccount}`;
        return this.api.get(uri).pipe(map((result) => {
            if (result !== null && result !== undefined) {
                return result;
            }
            throw 'Houve um erro ao buscar os dados!';
        }), catchError((err) => {
            return of(err);
        }));
    }
    getListVehicles(uuidAccountPayment, uuidWhiteLabel) {
        const uri = `${SPE_VIEW_N_PRE_PIX_PROXY}/v1/detran/list-vehicles/account-payment/${uuidAccountPayment}/white-label/${uuidWhiteLabel}`;
        return this.api.get(uri).pipe(map((result) => {
            if (result !== null && result !== undefined) {
                return result;
            }
            throw 'Houve um erro ao buscar os dados!';
        }), catchError((err) => {
            return of(err);
        }));
    }
    createVehicle(body) {
        const uri = `${SPE_VIEW_N_PRE_PIX_PROXY}/v1/detran/save-vehicle`;
        return this.api.post(uri, body).pipe(map((result) => {
            if (result !== null && result !== undefined) {
                return result;
            }
            throw 'Houve um erro ao buscar os dados!';
        }), catchError((err) => {
            return of(err);
        }));
    }
    deleteVehicle(uuidVehicle) {
        const uri = `${SPE_VIEW_N_PRE_PIX_PROXY}/v1/detran/remove-vehicle/${uuidVehicle}`;
        return this.api.delete(uri).pipe(map((result) => {
            if (result !== null && result !== undefined) {
                return result;
            }
            throw 'Houve um erro ao buscar os dados!';
        }), catchError((err) => {
            return of(err);
        }));
    }
};
SpeViewNDetran = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeViewNDetran);

const SPE_J_CASHOUT = '/spe-j-cash-out';
let SpeJCashOutProxy = class SpeJCashOutProxy {
    constructor(api) {
        this.api = api;
    }
    payment(body) {
        const uri = `${SPE_J_CASHOUT}/api/vehicle-payment-debit`;
        return this.api.post(uri, body, body.uuidAccountPayment);
    }
};
SpeJCashOutProxy = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeJCashOutProxy);

const SPE_VIEW_N_PRE_PIX_PROXY$1 = '/spe-n-detran';
let SpeNDetran = class SpeNDetran {
    constructor(api) {
        this.api = api;
    }
    createVehicle(body) {
        const uri = `${SPE_VIEW_N_PRE_PIX_PROXY$1}/v1/detran/save-vehicle`;
        return this.api.post(uri, body, body.uuidAccountPayment).pipe(map((result) => {
            if (result !== null && result !== undefined) {
                return result;
            }
            throw 'Houve um erro ao buscar os dados!';
        }), catchError((err) => {
            return of(err);
        }));
    }
    deleteVehicle(uuidVehicle) {
        const uri = `${SPE_VIEW_N_PRE_PIX_PROXY$1}/v1/detran/remove-vehicle/${uuidVehicle}`;
        return this.api.delete(uri).pipe(map((result) => {
            if (result !== null && result !== undefined) {
                return result;
            }
            throw 'Houve um erro ao buscar os dados!';
        }), catchError((err) => {
            return of(err);
        }));
    }
};
SpeNDetran = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [ApiService])
], SpeNDetran);

let UiPxDetranModule = class UiPxDetranModule {
};
UiPxDetranModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [
            SpeViewNDetran,
            SpeNDetran,
            SpeJCashOutProxy
        ]
    })
], UiPxDetranModule);

class PaymentDetran {
}

export { PaymentDetran, SpeJCashOutProxy, SpeNDetran, SpeViewNDetran, UiPxDetranModule };
//# sourceMappingURL=wlp-ui-px-detran.js.map
